import PreviewScreen from '~/components/preview/PreviewScreen'
import ScreenLayout from '~/layouts/ScreenLayout'

const Preview = () => {
  return (
    <ScreenLayout>
      <PreviewScreen />
    </ScreenLayout>
  )
}

export default Preview
